import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] text-white border-t border-white/10 pt-16 pb-8">
      <div className="container mx-auto px-4">
        {/* Main footer content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_e6901769-cd5f-4b08-bd85-12bd11f43a4d/artifacts/fzjxx274_ChatGPT%20Image%20Mar%2027%2C%202026%2C%2006_48_57%20PM.png" 
              alt="Professional Garage Door Service" 
              className="h-20 w-auto mb-4 bg-white p-2 rounded-lg"
            />
            <p className="text-neutral-400 mb-4">
              Saskatchewan's trusted garage door experts. Premium products, best workmanship, quality service every time.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">Home</a>
              </li>
              <li>
                <a href="#services" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">Services</a>
              </li>
              <li>
                <a href="#about" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">About Us</a>
              </li>
              <li>
                <a href="#faq" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">FAQ</a>
              </li>
              <li>
                <a href="#quote" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">Get a Quote</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Our Services</h3>
            <ul className="space-y-3 text-neutral-400">
              <li>Installation</li>
              <li>Repair & Maintenance</li>
              <li>Opener Service</li>
              <li>Spring Replacement</li>
              <li>Emergency Service</li>
              <li>Commercial Service</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${businessInfo.phone}`} className="flex items-start gap-3 text-neutral-400 hover:text-[#D4AF37] transition-colors">
                  <Phone size={20} className="flex-shrink-0 mt-1" />
                  <span className="font-semibold text-lg">{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${businessInfo.email}`} className="flex items-start gap-3 text-neutral-400 hover:text-[#D4AF37] transition-colors">
                  <Mail size={20} className="flex-shrink-0 mt-1" />
                  <span>{businessInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-neutral-400">
                <MapPin size={20} className="flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-white mb-1">{businessInfo.address}</p>
                  <p className="text-sm">{businessInfo.serviceArea}</p>
                </div>
              </li>
              <li className="flex items-start gap-3 text-[#D4AF37]">
                <Clock size={20} className="flex-shrink-0 mt-1" />
                <span className="font-semibold">{businessInfo.availability}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-neutral-400 text-sm">
              © {currentYear} Professional Garage Door Service. All rights reserved.
            </p>
            
            <div className="flex items-center gap-6">
              <a href="#" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-neutral-400 hover:text-[#D4AF37] transition-colors">
                Terms of Service
              </a>
            </div>

            <div className="flex items-center gap-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-[#0F0F11] border border-white/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#0F0F11] border border-white/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
